import { FONT_UNDO_REDO_SET_STATE } from "../actions/types";

const initialState = { obj: null };

const fontUndoRedoReducer = (state = initialState, action) => {
  switch (action.type) {
    case FONT_UNDO_REDO_SET_STATE:
      return action.payload;
    default:
      return state;
  }
};

export default fontUndoRedoReducer;
